import { render } from "./listeRevue.vue?vue&type=template&id=2232dca8&scoped=true"
import script from "./listeRevue.vue?vue&type=script&lang=js"
export * from "./listeRevue.vue?vue&type=script&lang=js"

import "./listeRevue.vue?vue&type=style&index=0&id=2232dca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2232dca8"]])

export default __exports__